"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.BrandColumnFullWidthProps = exports.BrandColumnProps = void 0;
const constants_1 = require("utils/constants");
exports.BrandColumnProps = [
    {
        show: true,
        field: 'code',
        title: 'Code',
        width: '100px',
        filter: 'text'
    },
    {
        show: true,
        field: 'name',
        title: 'Coal Brand',
        width: '400px',
        filter: 'text'
    },
    {
        show: true,
        field: 'color',
        title: 'Color Brand',
        width: '200px',
        filter: 'text'
    },
    {
        show: true,
        field: 'modified_date',
        title: 'Modified Date',
        width: '220px',
        filter: 'date',
        format: `${constants_1.formatGridDate.ddMMYYYY} ${constants_1.formatGridDate.hhMM}`
    },
    {
        show: true,
        field: 'modified_by',
        title: 'Modified By',
        width: '180px',
        filter: 'text'
    },
    {
        show: true,
        field: 'is_active',
        title: 'Status',
        width: '140px',
        filter: 'boolean'
    },
];
exports.BrandColumnFullWidthProps = [
    ...exports.BrandColumnProps
];
exports.BrandColumnFullWidthProps[1] = {
    show: true,
    field: 'name',
    title: 'Coal Brand',
    width: 'auto',
    filter: 'text'
};
